import './About.css';

function About() {
  return (
    <div className="about">
      <img src="/images/about.png" alt="Katie Schmid" className="about-image" />
      <p>
        Katie Schmid has felt a passion for the arts since an early age. This
        passion, no doubt, arose from the love and dedication of her mother who
        fostered a love for the arts in their family life. With the strong
        encouragement of her art teachers also, Katie pursued both her BFA and
        MFA at the Laguna College of Art of Design. From the love of painting in
        her youth to the present, her work has now blossomed, revealing the
        timeless elements of deep spirituality, natural beauty, and metaphysical
        transcendence within each of her paintings. She is indebted to the
        inspiring mentorships of visionary artists, such as John Brosio, Leon
        Kortenkamp, Betty Shelton, and Michael Harnish.
      </p>
      <p>When asked about her motivation for painting, Katie described her process as follows:</p>
      <blockquote>
        &ldquo;I strive to use nature to reveal what can be seen as holy and sacred.
        When painting nature and the figure or animals in relation to it, I
        establish points of familiarity for the viewer. Although these landmarks
        and symbols are recognizably connected to everyday life, the simple can
        communicate the profound, and transcend the everyday to higher mysteries.
        In other words, paintings can become a conduit for spiritual thought and
        growth. I have been able to take similar themes and express them in a more
        approachable and relatable way. Whether through symbolism of animals,
        panoramas of nature, or the beauty of the human figure, I have been able
        to combine these elements into poetic works and expressions of
        spirituality. As I continue to paint, I will keep this truthful remark of
        Albert Einstein in mind, &lsquo;The most beautiful experience we can have is
        the mysterious &mdash; the fundamental emotion which stands at the cradle of
        true art and true science.&rsquo; In sharing with Einstein, I revel in those
        sublime mysteries. Art has led me there and the journey has just begun.&rdquo;
      </blockquote>
    </div>
  );
}

export default About;
